














































































































import { Component, Prop, Mixins } from "vue-property-decorator";
import { IFilter, ISorter } from "@/models/tables";
import {
  HookFilter,
  AccessRoleFilter,
  DateCreatedFilter,
  ObjectTypeFilter
} from "@/data/filters/timeline";
import { TimelineType } from "./timelineProvider";
import TimelineProvider from "@/components/app/global/timelineComponent/timelineProvider";
import Context from "@/mixins/context";
import { CreateElement } from "vue";
import { NotificationCategoryCodes } from "@/data/enums/notifications";

@Component({
  components: {
    "event-message": () =>
      import("@/components/app/global/timelineComponent/eventMessage.vue")
  }
})
export default class TimelineTableView extends Mixins(
  TimelineProvider,
  Context
) {
  @Prop({
    default: TimelineType.TABLE,
    validator: val => val === TimelineType.TABLE
  })
  public declare timelineType: string;

  @Prop({ default: 10 })
  public declare limit: number;

  @Prop({ default: true })
  public autoLinkRows!: boolean;

  public filters: IFilter[] = [];

  public sorters: ISorter[] = [
    {
      field: "created_at",
      label: this.$t("_.date_created")
    }
  ];

  public async created() {
    this.filters = await this.getFilters();
    this.initTimelineProvider();
  }

  public getSrc(user) {
    return this.$_.get(user, "image.full_url");
  }

  public async getFilters() {
    const config: Parameters<typeof HookFilter>[0] = {};

    if (this.type === "contracts_product")
      config.categoryCode = NotificationCategoryCodes.CONTRACTS_PRODUCT;
    else if (this.type === "invoice") {
      config.categoryCode = NotificationCategoryCodes.INVOICE;
      config.hookCodeLike = "invoice_%"; // To prevent showing basket categories
    } else if (this.type === "bulk_action")
      config.categoryCode = NotificationCategoryCodes.BULK_ACTION;

    return [
      HookFilter(config),
      AccessRoleFilter(),
      DateCreatedFilter(),
      ObjectTypeFilter()
    ];
  }

  public rawEventCell(sourceEvent) {
    return {
      render: (h: CreateElement) =>
        h(
          "td",
          {
            class: "is-compact is-paddingless has-cursor-pointer",
            on: {
              click: (event: Event) => {
                event.preventDefault();
                event.stopPropagation();
                this.openLogModal(sourceEvent);
              }
            }
          },
          [
            h(
              "b-tooltip",
              {
                props: {
                  label: this.$t("_.view_raw_event_data"),
                  position: "is-left",
                  type: "is-dark"
                }
              },
              [h("span", { class: "u-raw-data-icon" })]
            )
          ]
        )
    };
  }
}
